<p-sidebar [visible]="service.panelOpen()"
           (visibleChange)="onVisibleChange($event)"
           position="right"
           [style]="{ width: '24rem', maxWidth: '95vw' }"
           styleClass="!bg-white dark:!bg-night-surface !text-ink dark:!text-night-text emit-notifications-panel">
  <ng-template pTemplate="header">
    <div class="flex items-center justify-between gap-4 w-full">
      <p class="text-base font-semibold text-ink dark:text-night-text">Notifications</p>
      @if (service.unreadCount() > 0) {
        <button type="button" (click)="markAllRead()"
                class="text-xs font-bold text-green dark:text-green-light hover:underline">
          Mark all as read
        </button>
      }
    </div>
  </ng-template>

  <div class="-mx-6 -my-4">
    @if (service.loading() && !hasItems()) {
      <div class="flex items-center justify-center py-16 text-ink-mid dark:text-night-mid">
        <i class="pi pi-spin pi-spinner text-2xl text-green dark:text-green-light"></i>
      </div>
    } @else if (!hasItems()) {
      <!-- Empty state -->
      <div class="flex flex-col items-center justify-center px-6 py-16 text-center">
        <div class="h-16 w-16 rounded-full bg-green-pale dark:bg-night-raised flex items-center justify-center text-green dark:text-green-light">
          <i class="pi pi-bell text-2xl"></i>
        </div>
        <p class="mt-5 text-base font-bold text-ink dark:text-night-text">You're all caught up</p>
        <p class="mt-1 text-sm text-ink-mid dark:text-night-mid">No notifications yet.</p>
      </div>
    } @else {
      <ul class="divide-y divide-line dark:divide-line-dark">
        @for (n of service.items(); track n.id) {
          <li (click)="onRowClick(n)"
              class="group relative px-6 py-4 cursor-pointer transition-colors
                     hover:bg-green-pale/40 dark:hover:bg-night-raised"
              [ngClass]="!n.isRead ? 'bg-green-pale dark:bg-green/5' : ''">
            @if (!n.isRead) {
              <span class="absolute left-0 top-0 bottom-0 w-1 bg-green dark:bg-green-light"></span>
            }
            <div class="flex items-start gap-3">
              <span class="h-9 w-9 shrink-0 rounded-xl flex items-center justify-center"
                    [class]="iconFor(n.type).classes">
                <i class="pi text-sm" [class]="iconFor(n.type).icon"></i>
              </span>
              <div class="min-w-0 flex-1">
                <p class="text-sm leading-snug text-ink dark:text-night-text"
                   [ngClass]="n.isRead ? 'font-medium opacity-70' : 'font-bold'">
                  {{ n.title }}
                </p>
                <p class="mt-0.5 text-xs text-ink-mid dark:text-night-mid leading-relaxed"
                   [ngClass]="n.isRead ? 'opacity-70' : ''">
                  {{ n.message }}
                </p>
                <p class="mt-1.5 text-[11px] font-semibold uppercase tracking-wider text-ink-soft dark:text-night-soft">
                  {{ timeAgo(n.createdAt) }}
                </p>
              </div>
              <button type="button" (click)="onDelete($event, n)"
                      [attr.aria-label]="'Delete notification'"
                      class="shrink-0 h-8 w-8 rounded-full text-ink-soft dark:text-night-soft
                             opacity-0 group-hover:opacity-100 transition-opacity
                             hover:bg-red-50 dark:hover:bg-red-950/30 hover:text-red-600 dark:hover:text-red-400
                             flex items-center justify-center">
                <i class="pi pi-trash text-sm"></i>
              </button>
            </div>
          </li>
        }
      </ul>

      @if (canLoadMore()) {
        <div class="px-6 py-4 text-center">
          <button type="button" (click)="loadMore()"
                  [disabled]="service.loading()"
                  class="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold
                         border border-line dark:border-line-dark
                         text-ink dark:text-night-text
                         hover:border-green dark:hover:border-green-light
                         hover:bg-green-pale dark:hover:bg-night-raised
                         transition-colors disabled:opacity-50">
            @if (service.loading()) {
              <i class="pi pi-spin pi-spinner"></i> Loading…
            } @else {
              Load more
            }
          </button>
        </div>
      }
    }
  </div>
</p-sidebar>
